"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _calculator = _interopRequireDefault(require("cccisd-icons/calculator3"));
var _userCheck = _interopRequireDefault(require("cccisd-icons/user-check"));
var _reportVariables = _interopRequireDefault(require("./reportVariables.graphql"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _style = _interopRequireDefault(require("./style.css"));
var _excluded = ["doNotAllowEmptyDataDownload"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CodebookReport = function CodebookReport(_ref) {
  var _ref$doNotAllowEmptyD = _ref.doNotAllowEmptyDataDownload,
    doNotAllowEmptyDataDownload = _ref$doNotAllowEmptyD === void 0 ? true : _ref$doNotAllowEmptyD,
    props = _objectWithoutProperties(_ref, _excluded);
  var closeModal = props.closeModal,
    assignment = props.assignment,
    surveyHandles = props.surveyHandles,
    typeFilter = props.typeFilter,
    filter = props.filter,
    limit = props.limit,
    elementIcons = props.elementIcons,
    convertLoadedData = props.convertLoadedData;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var date = (0, _format["default"])(new Date(), 'MM-dd-yyyy');
  (0, _react.useEffect)(function () {
    var getData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, responseData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _cccisdApollo.client.query({
                query: _reportVariables["default"],
                variables: {
                  assignmentId: [assignment.assignmentId],
                  surveyHandle: surveyHandles,
                  typeFilter: typeFilter,
                  filter: filter,
                  limit: limit,
                  groupId: [assignment.groupId]
                },
                fetchPolicy: 'network-only'
              });
            case 1:
              response = _context.v;
              responseData = typeof convertLoadedData === 'function' ? convertLoadedData(response.data) : response.data;
              if (!(!responseData.metrics.variableList.length && doNotAllowEmptyDataDownload)) {
                _context.n = 2;
                break;
              }
              (0, _cccisdNotification["default"])({
                message: 'There is no data to download',
                type: 'danger'
              });
              setLoading(false);
              closeModal && closeModal();
              return _context.a(2);
            case 2:
              setData(responseData);
              setLoading(false);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getData() {
        return _ref2.apply(this, arguments);
      };
    }();
    getData();
  }, [closeModal, doNotAllowEmptyDataDownload]);
  var abbreviateLanguage = function abbreviateLanguage(name) {
    return name.replace('(English)', '(EN)').replace('(Spanish)', '(ES)');
  };
  var isURL = function isURL(string) {
    if (!string) {
      return false;
    }
    if (string.includes('https:') || string.includes('http:')) {
      return true;
    }
    return false;
  };
  var getFormattedRows = function getFormattedRows(rows) {
    var formattedRows = [];
    var currentRow = null;
    rows.forEach(function (row) {
      if (!currentRow || currentRow.row.key.entityId !== row.key.entityId) {
        if (currentRow) {
          formattedRows.push(currentRow);
        }
        currentRow = {
          row: row,
          rowspan: 0,
          subRows: []
        };
      }
      currentRow.rowspan++;
      currentRow.subRows.push(row);
    });
    if (currentRow) {
      formattedRows.push(currentRow);
    }
    return formattedRows;
  };
  var getResponseValues = function getResponseValues(row) {
    if (row.key.entity.type === 'slider') {
      var _row$key$content = row.key.content,
        minimum = _row$key$content.minimum,
        maximum = _row$key$content.maximum;
      if (minimum && maximum) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, "Min: ", minimum), " ", /*#__PURE__*/_react["default"].createElement("div", null, "Max: ", maximum));
      }
    }
    if (row.mapping) {
      var entries = Object.entries(row.mapping);
      var identical = entries.every(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return value === key;
      });
      if (identical) {
        return entries.map(function (_ref5, i) {
          var _ref6 = _slicedToArray(_ref5, 1),
            key = _ref6[0];
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, key);
        });
      }
      return entries.map(function (_ref7, i) {
        var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: i
        }, value, " - ", key);
      });
    }
    return null;
  };
  var renderAdditonalColumns = function renderAdditonalColumns(item, title) {
    var isIdentifying = item.key.isIdentifying;
    var hasFormula = item.formulaInput;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("td", {
      className: _style["default"].secondCol
    }, /*#__PURE__*/_react["default"].createElement("div", null, item.key.metric), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].statusBox
    }, /*#__PURE__*/_react["default"].createElement("i", null, (0, _capitalize2["default"])(item.type)), ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].idSpan
    }, isIdentifying && /*#__PURE__*/_react["default"].createElement(_userCheck["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].formulaSpan
    }, hasFormula && /*#__PURE__*/_react["default"].createElement(_calculator["default"], null)))), /*#__PURE__*/_react["default"].createElement("td", {
      className: _style["default"].thirdCol
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("strong", null, item.reportHeader)), /*#__PURE__*/_react["default"].createElement("div", null, item.label)), /*#__PURE__*/_react["default"].createElement("td", {
      className: _style["default"].fourthCol
    }, title === 'Detailed Usage' ? item.key.surveyList[0].label : getResponseValues(item)));
  };
  var renderTableRows = function renderTableRows(title, rows) {
    var formattedRows = getFormattedRows(rows);
    return formattedRows.map(function (frow) {
      var row = frow.row,
        rowspan = frow.rowspan,
        subRows = frow.subRows;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: row.variableId
      }, subRows.map(function (item, index) {
        var isLast = index === subRows.length - 1;
        var type = row.key.entity.type;
        var notQuantQual = !['qualitative', 'quantitative'].includes(item.type);
        var notUsage = !item.type.includes('usage');
        var notSummary = !item.type.includes('summary');
        if (index === 0) {
          return /*#__PURE__*/_react["default"].createElement("tr", {
            key: item.key.keyId,
            className: isLast ? _style["default"].lastRow : ''
          }, /*#__PURE__*/_react["default"].createElement("td", {
            rowSpan: rowspan,
            className: _style["default"].firstCol,
            style: {
              padding: 0,
              width: '30%'
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].typeBox
          }, notQuantQual ? /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].usageFormula
          }, notUsage ? 'Formula' : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, notSummary ? 'Detailed Usage' : 'Summary Usage')) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].typeSpan
          }, elementIcons[type], " ", type), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].typeSpan
          }, item.key.flow.language))), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].titleBox,
            style: {
              wordBreak: "".concat(isURL(item.key.title) ? 'break-all' : 'break-word')
            }
          }, item.key.title)), renderAdditonalColumns(item, title));
        }
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: item.key.keyId,
          className: isLast ? _style["default"].lastRow : ''
        }, renderAdditonalColumns(item, title));
      }));
    });
  };
  var getSurveyVariables = function getSurveyVariables(survey) {
    var filteredList = data.metrics.variableList.filter(function (item) {
      return item.key.surveyList.some(function (thing) {
        return thing.surveyHandle === survey.flowHandle;
      }) && item.key.flow.language === survey.language;
    });

    // Quantitative Qualitiative Variables
    var qualQuant = filteredList.filter(function (item) {
      return ['quantitative', 'qualitative', 'additional_coding', 'detailed_usage', 'correct'].includes(item.type);
    });
    // Summary Usage Variables
    var summaryUsage = data.metrics.variableList.filter(function (item) {
      return item.type === 'summary_usage';
    });

    // Formulas
    var formulas = data.metrics.variableList.filter(function (item) {
      return item.type === 'formula';
    });
    return {
      qualQuant: qualQuant,
      summaryUsage: summaryUsage,
      formulas: formulas
    };
  };
  var renderTable = function renderTable(name, title, variables) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", {
      className: _style["default"].surveyTitle
    }, title === 'Qualitiative/Quantitative' ? name : title), /*#__PURE__*/_react["default"].createElement("table", {
      className: "table table-bordered reportTable"
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
      className: "".concat(_style["default"].colHead, " ").concat(_style["default"].firstCol)
    }, "Question"), /*#__PURE__*/_react["default"].createElement("th", {
      className: "".concat(_style["default"].colHead, " ").concat(_style["default"].secondCol)
    }, "Metric"), /*#__PURE__*/_react["default"].createElement("th", {
      className: "".concat(_style["default"].colHead, " ").concat(_style["default"].thirdCol)
    }, "Variable"), /*#__PURE__*/_react["default"].createElement("th", {
      className: "".concat(_style["default"].colHead, " ").concat(_style["default"].fourthCol)
    }, title === 'Detailed Usage' ? 'Survey' : 'Response Values'))), /*#__PURE__*/_react["default"].createElement("tbody", null, renderTableRows(title, variables))));
  };
  var renderSurveys = function renderSurveys() {
    var surveyList = data.flows.assignment.flowList;
    var hasSurveyHandles = surveyHandles.length > 0;
    var surveys = hasSurveyHandles ? surveyHandles : surveyList;
    return surveys.map(function (thing, i) {
      var match = hasSurveyHandles ? surveyList.find(function (item) {
        return item.flowHandle === thing;
      }) : thing;
      var variables = getSurveyVariables(match);
      var surveyName = abbreviateLanguage(match.name);
      var lastSurvey = i + 1 === surveyList.length;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: match.surveyId
      }, variables.qualQuant.length > 0 && renderTable(surveyName, 'Qualitiative/Quantitative', variables.qualQuant), variables.summaryUsage.length > 0 && lastSurvey && renderTable(surveyName, 'Summary Usage', variables.summaryUsage), variables.formulas.length > 0 && lastSurvey && renderTable(surveyName, 'Formulas', variables.formulas));
    });
  };
  if (!data) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: loading
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
    downloadFilename: "".concat(data.groups.questproject.group.label, " Codebook")
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].assignmentTitle
  }, /*#__PURE__*/_react["default"].createElement("h4", null, data.groups.questproject.group.label, " - ", data.flows.assignment.label), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "Exported:"), " ", /*#__PURE__*/_react["default"].createElement("div", null, date))), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].legend
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_userCheck["default"], null), ": Variable is identifiable."), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_calculator["default"], null), ": Variable is part of a formula.")), renderSurveys()));
};
CodebookReport.propTypes = {
  closeModal: _propTypes["default"].func,
  assignment: _propTypes["default"].object,
  surveyHandles: _propTypes["default"].array,
  typeFilter: _propTypes["default"].array,
  filter: _propTypes["default"].object,
  limit: _propTypes["default"].number,
  elementIcons: _propTypes["default"].object,
  convertLoadedData: _propTypes["default"].func,
  doNotAllowEmptyDataDownload: _propTypes["default"].bool
};
CodebookReport.defaultProps = {
  surveyHandles: []
};
var _default = exports["default"] = CodebookReport;